import * as Sentry from "@sentry/react";

const API_BASE = (import.meta.env.VITE_API_URL ?? "").replace(/\/+$/, "");

if (import.meta.env.PROD && API_BASE && !/^https?:\/\//i.test(API_BASE)) {
  throw new Error(
    `VITE_API_URL must include a protocol (http:// or https://). Got: ${API_BASE}`,
  );
}

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      ...init,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...init?.headers,
      },
    });
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        area: "api",
        path,
      },
    });
    throw error;
  }

  if (!response.ok) {
    Sentry.captureMessage(`API request failed: ${path} ${response.status}`, "warning");
  }

  return response;
}
